import * as React from "react"
import {Box} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";

import MatcherSKUsTargetActionsZoom from "./Zoom";
import MatcherSKUsTargetActionsPagination from "./Pagination";


export default function MatcherSKUsTargetActions({ targetIndex, handleChangeIndex, isLoadingMapping }) {

	return <CardSeeker sx={{ width: 1}} contentProps={{ sx: { display: 'flex', justifyContent: 'space-between' } }}>
		<MatcherSKUsTargetActionsZoom />

		<MatcherSKUsTargetActionsPagination
			number={targetIndex}
			setNumber={handleChangeIndex}
			isLoadingMapping={isLoadingMapping}
		/>

		<Box />
	</CardSeeker>
}